import { render, staticRenderFns } from "./WhopperForgotPassword.vue?vue&type=template&id=1d98a77c&scoped=true"
import script from "./WhopperForgotPassword.vue?vue&type=script&lang=js"
export * from "./WhopperForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./WhopperForgotPassword.vue?vue&type=style&index=0&id=1d98a77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98a77c",
  null
  
)

export default component.exports